import React, {useState, useEffect} from 'react'
import {Button, Form, Input, Row, Col, message} from 'antd'

import {useHistory} from 'react-router-dom'
import API from '../../api'
import {useDispatch} from 'react-redux'
import {saveUser} from 'reducers/user'
import {MobileOutlined, SafetyCertificateOutlined} from '@ant-design/icons'
const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 24,
  },
}

const COUNTDOWN = 60

const phoneRules = [
  {
    required: true,
    message: '请输入正确的手机号码!',
    pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
  },
]

const captchaRules = [
  {
    required: true,
    message: '请输入正确的验证码！',
    pattern: /^\d{6}$/,
  },
]
const PhoneForm = () => {
  const [form] = Form.useForm()
  const [sendingCaptcha, setSendingCaptcha] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [countDown, setCountDown] = useState(COUNTDOWN)
  const dispatch = useDispatch()
  let history = useHistory()

  const loginWithCaptcha = values => {
    values.type = 'captcha'
    API.Login(values).then(res => {
      switch (res.code) {
        case 1003:
          form.setFields([{errors: ['验证码错误'], name: 'captcha'}])
          break
        default:
          dispatch(saveUser(res.data))
          history.push('/home')
          break
      }
    })
  }

  const onFinishFailed = errorInfo => {}

  useEffect(() => {
    var cInterval
    if (sendingCaptcha && countDown > 0) {
      cInterval = setInterval(() => {
        setCountDown(countDown - 1)
      }, 1000)
    }

    if (countDown === 0) {
      clearInterval(cInterval)
      setSendingCaptcha(false)
      let pattern = /^1[3|4|5|7|8|9][0-9]\d{8}$/
      if (pattern.test(form.getFieldValue('phone'))) {
        setDisabled(false)
      } else {
        setDisabled(true)
      }
    }
    return () => {
      clearInterval(cInterval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendingCaptcha, countDown])

  // 发送验证码
  const handleClickCaptcha = () => {
    API.SendSms(form.getFieldValue('phone')).then(res => {
      switch (res.code) {
        case 1002:
          form.setFields([{errors: ['用户不存在'], name: 'phone'}])
          break
        case 400:
          message.error({
            content: '输入手机号不正确，请重新输入',
            duration: 2,
          })
          break
        default:
          setCountDown(COUNTDOWN)
          setSendingCaptcha(true)
          setDisabled(true)
          message.success({
            content: '发送验证码成功，请注意查收',
            duration: 2,
          })
      }
    })
  }

  const handlePhoneChange = (changedValues, allValues) => {
    let pattern = /^1[3|4|5|7|8|9][0-9]\d{8}$/
    if (!sendingCaptcha && pattern.test(allValues.phone)) {
      setDisabled(false)
    } else if (sendingCaptcha || !pattern.test(allValues.phone)) {
      setDisabled(true)
    }
  }
  return (
    <>
      <Form
        onFinish={loginWithCaptcha}
        onFinishFailed={onFinishFailed}
        {...formItemLayout}
        form={form}
        labelAlign="left"
        onValuesChange={handlePhoneChange}
      >
        <Form.Item name="phone" rules={phoneRules}>
          <Input
            size="large"
            placeholder="手机号"
            className="login-input"
            prefix={<MobileOutlined style={{color: '#BFBFBF'}} />}
            maxLength={11}
            allowClear
          />
        </Form.Item>
        <Form.Item style={{marginBottom: 0}}>
          <Row justify="space-between">
            <Col span={16}>
              <Form.Item name="captcha" rules={captchaRules} validateTrigger="onSubmit">
                <Input
                  size="large"
                  placeholder="验证码"
                  className="login-input"
                  autoComplete="new-password"
                  maxLength={6}
                  prefix={<SafetyCertificateOutlined style={{color: '#BFBFBF'}} />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button
                onClick={handleClickCaptcha}
                disabled={disabled}
                className="login-captcha-button bold"
                size="large"
              >
                {sendingCaptcha ? countDown + 's' : '获取验证码'}
              </Button>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            size="large"
            style={{marginTop: 36}}
          >
            登录
          </Button>
        </Form.Item>
      </Form>
    </>
  )
}

export default PhoneForm
